import { CreatableSelectProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { Combobox, type ComboboxOption } from '@/components/ui/combobox'

export default function CreatableSelect(props: CreatableSelectProps) {
  const {
    inputId,
    label,
    onChange,
    options,
    value,
    onFocus,
    onBlur,
    required,
    disabled
  } = props

  const comboboxOptions: ComboboxOption[] = options.map(option => ({
    label: option.label,
    value: `${option.value}`,
    prefix: option.prefix
  }))

  // A value matching an existing option round-trips as that option's numeric
  // value; anything else is free text the user created.
  function fromComboboxValue(newValue: string | null): string | number | null {
    if (newValue === null) return null

    return options.some(option => `${option.value}` === newValue)
      ? Number.parseInt(newValue, 10)
      : newValue
  }

  return (
    <InputFieldset {...props}>
      <Combobox
        creatable
        options={comboboxOptions}
        value={value !== null ? `${value}` : null}
        onChange={newValue => onChange(fromComboboxValue(newValue))}
        id={inputId}
        aria-label={label}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
